import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { FactoryListing, FactoryAddEdit } from './Pages';

export const FactoryRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={FactoryListing} />
        <Route exact path = {`${match.path}/AddEdit`} component={FactoryAddEdit} />
    </Fragment>
)